import type { LabeledAttribute, ProductAttribute } from '@libs/attribute.helper';
import { getAttributeValue } from '@libs/attribute.helper';
import type { CfCaseProductBoxProps } from '@libs/cfCase.helper';
import { getCFCasePrice } from '@libs/cfCase.helper';
import { sortByParam } from '@libs/comparer.helper';
import type { AssociationProductFragmentEnhanced, PriceFragmentEnhanced } from '@models/enhanced-fragments';
import { ProductHelper } from '@models/graphql';
import type { SharedProductPagePropsPrices } from '@product/ProductPage/ProductPage';

/**
 * returns the props needed for the cfCase ProductBox from a cfCase hsProduct
 */
export const getCfCaseProductBoxProps = (
  cfCase: AssociationProductFragmentEnhanced,
  priceOverwriteProps: SharedProductPagePropsPrices | undefined
): CfCaseProductBoxProps => {
  const teaserImage = ProductHelper.getTeaserImage(cfCase);
  let { pricePerUnit, currencyCode } = getCFCasePrice(
    cfCase.prices.sort(sortByParam<PriceFragmentEnhanced>(item => item.discount_threshold))[0]
  );

  // overwrite prices e.g. for dynamic price regarding users priceCountry
  const priceOverwrite = priceOverwriteProps?.associatedProductPrices.find(p => p.id === cfCase.id);
  if (priceOverwrite && priceOverwrite.baseUnitCentPrice != null) {
    pricePerUnit = priceOverwrite.baseUnitCentPrice;
    currencyCode = priceOverwrite.quantityDiscounts[0].currency_code ?? null;
  }

  const caseCode =
    (cfCase.attributes?.cf_case_size as LabeledAttribute<string> | undefined)?.value_key?.split('_').at(-1) ?? '';
  const caseDesign = cfCase.attributes?.attr_design_simple_select as { value: string; value_key: string } | undefined;

  return {
    sku: cfCase?.id || '',
    pricePerUnit,
    currencyCode,
    title: getAttributeValue<string>(cfCase.attributes?.series_description as ProductAttribute<string>) ?? '',
    image: teaserImage || undefined,
    sorting: getAttributeValue<number>(cfCase.attributes?.sorting as ProductAttribute<number>) ?? 0,
    design: caseDesign?.value_key,
    caseCode,
  };
};
